export enum PhoneNumberFormat {
  International = 'INTERNATIONAL',
  National = 'NATIONAL',
}
//# sourceMappingURL=phone-number-format.enum.d.ts.map
